import React from 'react';
import { withMutastateCreator } from 'mutastate';
import globalState from './globalState';

export default withMutastateCreator(React, { instance: globalState })
